import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 41 41"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.73 31.029v1.955a.44.44 0 0 0 .586.41 32.778 32.778 0 0 1 9.937-1.385c4.1 0 7.79.599 10.431 1.562a.437.437 0 0 0 .586-.41v-2.132c-2.775-1.046-6.686-1.64-10.77-1.64s-7.99.594-10.771 1.64ZM25.252 21.672l-4.51-9.459-.242-.52-.246.52-4.95 10.39-7.924-6.928 2.177 13.53c2.952-1.03 6.802-1.587 10.935-1.587 4.132 0 7.98.557 10.931 1.587l2.185-13.53-7.909 6.928-.447-.93Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M22.37 9.275c0 2.492-3.739 2.492-3.739 0 0-2.494 3.738-2.494 3.738 0ZM7.95 13.383a1.517 1.517 0 1 0-3.033-.008 1.517 1.517 0 0 0 3.034.008ZM36.08 13.383c0 2.023-3.033 2.023-3.033 0s3.033-2.023 3.033 0Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }